export function demoUnionGetter(state) {
  return state.union.demoItem
}